import React from "react";
import { useParams } from "react-router-dom";
import { ResultCatastoPF } from "../components/result/ResultCatastoPF";
import { ResultCatastoPG } from "../components/result/ResultCatastoPG";
import { ResultVisuraCamerale } from "../components/result/ResultVisuraCamerale";
import { ResultCatastoIndirizzo } from "../components/result/ResultCatastoIndirizzo";
import { ResultCompany } from "../components/result/ResultCompany";
import { ResultVies } from "../components/result/ResultVies";

/* Mock fixtures - usate SOLO in dev per testare i layout senza chiamare OpenAPI.it.
   Rimuovibili al rilascio finale. */

const MOCK_CATASTO_PF = {
  id: "preview-pf-001",
  user_id: "preview-user",
  user_email: "admin@wattline.it",
  service_id: "catasto_ricerca_persona_fisica",
  service_name: "Visura catastale - Persona fisica",
  status: "completed",
  cache_hit: false,
  cost_cents: 180,
  created_at: "2026-05-12T00:45:12Z",
  completed_at: "2026-05-12T00:45:12Z",
  params: { cf: "RSSMRA80A01F205X" },
  response_data: {
    soggetto: {
      nome: "Mario",
      cognome: "Rossi",
      cf: "RSSMRA80A01F205X",
      data_nascita: "1980-01-01",
      luogo_nascita: "Milano",
      provincia_nascita: "MI",
      sesso: "M",
    },
    immobili: [
      { comune: "Milano", provincia: "MI", regione: "Lombardia" },
      { comune: "Milano", provincia: "MI", regione: "Lombardia" },
      { comune: "Milano", provincia: "MI", regione: "Lombardia" },
      { comune: "Pavia", provincia: "PV", regione: "Lombardia" },
      { comune: "Pavia", provincia: "PV", regione: "Lombardia" },
    ],
  },
};

const FIXTURES = {
  "catasto-pf": { component: ResultCatastoPF, data: MOCK_CATASTO_PF },
  "catasto-pg": {
    component: ResultCatastoPG,
    data: {
      id: "preview-pg-001",
      user_email: "admin@wattline.it",
      service_id: "catasto_ricerca_persona_giuridica",
      service_name: "Visura catastale - Persona giuridica (P.IVA)",
      status: "completed",
      cache_hit: false,
      cost_cents: 180,
      created_at: "2026-05-12T09:12:08Z",
      completed_at: "2026-05-12T09:12:08Z",
      params: { piva: "12345678901" },
      response_data: {
        soggetti: [
          {
            denominazione: "ACME S.r.l.",
            cf: "12345678901",
            piva: "12345678901",
            sede_comune: "Roma",
            sede_provincia: "RM",
            catasti: [
              { provincia: "RM", citta: "ROMA", fabbricati: 4, terreni: 0 },
              { provincia: "MI", citta: "MILANO", fabbricati: 2, terreni: 0 },
              { provincia: "TO", citta: "TORINO", fabbricati: 1, terreni: 0 },
            ],
          },
        ],
      },
    },
  },
  "catasto-pg-empty": {
    component: ResultCatastoPG,
    data: {
      id: "preview-pg-empty-001",
      user_email: "admin@wattline.it",
      service_id: "catasto_ricerca_persona_giuridica",
      service_name: "Visura catastale - Persona giuridica (P.IVA)",
      status: "completed",
      cache_hit: false,
      cost_cents: 180,
      created_at: "2026-05-12T14:30:00Z",
      completed_at: "2026-05-12T14:30:00Z",
      params: { piva: "99999999999" },
      response_data: {
        soggetti: [
          {
            denominazione: "EMPTY SOC. S.r.l.",
            piva: "99999999999",
            catasti: [],
          },
        ],
      },
    },
  },
  "visura-in-progress": {
    component: ResultVisuraCamerale,
    data: {
      id: "preview-visura-001",
      user_email: "admin@wattline.it",
      service_id: "visura_ord_societa_capitali",
      service_name: "Visura ordinaria - Società di capitali",
      status: "pending_external",
      cache_hit: false,
      cost_cents: 250,
      // -45s rispetto a "ora" per vedere il counter
      created_at: new Date(Date.now() - 45 * 1000).toISOString(),
      completed_at: null,
      params: { cf_piva_id: "12345678901" },
      openapi_state: "in erogazione",
      openapi_request_id: "ext-abc-001",
    },
  },
  "catasto-indirizzo-step1": {
    component: ResultCatastoIndirizzo,
    data: {
      id: "preview-ind-step1-001",
      user_email: "admin@wattline.it",
      service_id: "catasto_ricerca_indirizzo",
      service_name: "Cerca immobili per indirizzo",
      status: "completed",
      cache_hit: false,
      created_at: "2026-05-12T15:10:00Z",
      completed_at: "2026-05-12T15:10:00Z",
      params: { indirizzo: "Via Roma 42, Roma" },
      response_data: {
        id_indirizzo: "addr-7f3a2",
        indirizzo_normalizzato: "Via Roma, 42",
        comune: "Roma",
        provincia: "RM",
        cap: "00100",
        immobili: [
          { id_immobile: "im-001", foglio: "142", particella: "89", subalterno: "3", piano: "1", interno: "3", categoria: "A/2", consistenza_mq: 105 },
          { id_immobile: "im-002", foglio: "142", particella: "89", subalterno: "5", piano: "2", interno: "5", categoria: "A/2", consistenza_mq: 120 },
          { id_immobile: "im-003", foglio: "142", particella: "89", subalterno: "8", piano: "3", interno: "8", categoria: "A/3", consistenza_mq: 95 },
          { id_immobile: "im-004", foglio: "142", particella: "89", subalterno: "12", piano: "S1", interno: "BOX", categoria: "C/6", consistenza_mq: 18 },
        ],
      },
    },
  },
  "catasto-indirizzo-step2": {
    component: ResultCatastoIndirizzo,
    data: {
      id: "preview-ind-step2-001",
      user_email: "admin@wattline.it",
      service_id: "catasto_ricerca_indirizzo",
      service_name: "Cerca immobili per indirizzo",
      status: "completed",
      cache_hit: false,
      created_at: "2026-05-12T15:12:00Z",
      completed_at: "2026-05-12T15:12:00Z",
      params: { id_indirizzo: "addr-7f3a2", id_immobile: "im-002" },
      response_data: {
        immobile: {
          foglio: "142",
          particella: "89",
          subalterno: "5",
          comune_catastale: "H501",
          categoria: "A/2",
          categoria_descrizione: "Abitazione civile",
          classe: "5",
          consistenza_vani: 5.5,
          consistenza_mq: 120,
          rendita: 854.32,
          zona_censuaria: "2",
          piano: "2",
          interno: "5",
          indirizzo: "Via Roma, 42",
          comune: "Roma",
          provincia: "RM",
          cap: "00100",
        },
        intestatari: [
          { tipo: "PF", nome: "Mario", cognome: "Rossi", cf: "RSSMRA80A01F205X", quota: "1/1", titolo: "Piena proprietà" },
        ],
      },
    },
  },
  "visura-camerale-completed": {
    component: ResultVisuraCamerale,
    data: {
      id: "preview-visura-ok-001",
      user_email: "admin@wattline.it",
      service_id: "visura_ord_societa_capitali",
      service_name: "Visura ordinaria - Società di capitali",
      status: "completed",
      cache_hit: false,
      cost_cents: 250,
      created_at: "2026-05-12T10:00:00Z",
      completed_at: "2026-05-12T10:01:55Z",
      params: { cf_piva_id: "12345678901" },
      openapi_state: "evasa",
      pdf_filename: "visura_acme_srl.pdf",
      pdf_size_bytes: 192512,
      response_data: { denominazione: "ACME S.R.L." },
    },
  },
  "company-start": {
    component: ResultCompany,
    data: {
      id: "preview-cs-001",
      user_email: "admin@wattline.it",
      service_id: "company_it_start",
      service_name: "Cerca azienda - Dati base",
      status: "completed",
      cache_hit: false,
      cost_cents: 30,
      created_at: "2026-05-12T11:00:00Z",
      completed_at: "2026-05-12T11:00:01Z",
      params: { cf_piva: "12345678901" },
      response_data: {
        data: [
          {
            taxCode: "12345678901",
            vatCode: "12345678901",
            companyName: "ACME S.R.L.",
            legalForm: "Società a responsabilità limitata",
            status: "Attiva",
            startDate: "2010-03-15",
            address: {
              registeredOffice: {
                street: "Via Roma 42",
                city: "Roma",
                province: "RM",
                zipCode: "00100",
                region: "Lazio",
              },
            },
            contacts: {
              pec: "acme@pec.it",
              phone: "+39 06 12345678",
              email: "info@acme.it",
              website: "www.acme.it",
            },
            atecoClassification: {
              code: "62.01.00",
              sector: "Servizi IT",
              description: "Produzione di software non connesso all'edizione",
            },
          },
        ],
      },
    },
  },
  "vies-valid": {
    component: ResultVies,
    data: {
      id: "preview-vies-ok-001",
      user_email: "admin@wattline.it",
      service_id: "vies_check",
      service_name: "Verifica VIES (UE)",
      status: "completed",
      created_at: "2026-05-12T00:45:00Z",
      completed_at: "2026-05-12T00:45:02Z",
      params: { piva: "12345678901", country: "IT" },
      response_data: {
        data: {
          valid: true,
          countryCode: "IT",
          vatNumber: "12345678901",
          companyName: "ACME S.R.L.",
          address: "Via Roma 42, 00100 Roma (RM), Italia",
          requestDate: "2026-05-12T00:45:02Z",
          requestId: "req_8f3a2b1c",
        },
      },
    },
  },
  "vies-invalid": {
    component: ResultVies,
    data: {
      id: "preview-vies-ko-001",
      user_email: "admin@wattline.it",
      service_id: "vies_check",
      service_name: "Verifica VIES (UE)",
      status: "completed",
      created_at: "2026-05-12T01:10:00Z",
      completed_at: "2026-05-12T01:10:01Z",
      params: { piva: "00000000000", country: "IT" },
      response_data: {
        data: {
          valid: false,
          countryCode: "IT",
          vatNumber: "00000000000",
          companyName: null,
          address: null,
          requestDate: "2026-05-12T01:10:01Z",
          requestId: "req_xy1z9",
        },
      },
    },
  },
  "company-advanced": {
    component: ResultCompany,
    data: {
      id: "preview-ca-001",
      user_email: "admin@wattline.it",
      service_id: "company_it_advanced",
      service_name: "Cerca azienda - Dati avanzati",
      status: "completed",
      cache_hit: false,
      cost_cents: 80,
      created_at: "2026-05-12T11:30:00Z",
      completed_at: "2026-05-12T11:30:02Z",
      params: { cf_piva: "12345678901" },
      response_data: {
        data: [
          {
            taxCode: "12345678901",
            vatCode: "12345678901",
            companyName: "ACME S.R.L.",
            legalForm: "Società a responsabilità limitata",
            status: "Attiva",
            startDate: "2010-03-15",
            address: {
              registeredOffice: {
                street: "Via Roma 42",
                city: "Roma",
                province: "RM",
                zipCode: "00100",
                region: "Lazio",
              },
            },
            contacts: {
              pec: "acme@pec.it",
              phone: "+39 06 12345678",
              email: "info@acme.it",
              website: "www.acme.it",
            },
            atecoClassification: {
              code: "62.01.00",
              sector: "Servizi IT",
              description: "Produzione di software non connesso all'edizione",
            },
            financials: {
              revenue: 2400000,
              profit: 312000,
              equity: 1100000,
              employees: 24,
              year: 2024,
              profitTrendPercent: 18,
            },
          },
        ],
      },
    },
  },
};

export default function DevPreview() {
  const { slug } = useParams();
  const fixture = FIXTURES[slug];

  if (!fixture) {
    return (
      <div className="max-w-2xl">
        <h1 className="text-2xl font-semibold text-text-primary mb-4">Preview non trovata</h1>
        <p className="text-sm text-text-secondary mb-4">Slug disponibili:</p>
        <ul className="list-disc list-inside text-sm text-text-secondary">
          {Object.keys(FIXTURES).map((k) => (
            <li key={k}>
              <a className="text-accent hover:underline" href={`/dev/preview/${k}`}>{k}</a>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  const Comp = fixture.component;
  return <Comp request={fixture.data} />;
}
